module.exports = __webpack_public_path__ + "img/15.0ee73e94.png";